import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';

function noteTemplate(note) {
  if (note.type === 'idea') {
    return <IdeaListItem note={note} />;
  } else if (note.type === 'quote') {
    return <QuoteListItem note={note} />;
  } else {
    return <LinkListItem note={note} />;
  }
}

function NoteListItem({ note }) {
  return (<div className='note-list-item'>
    <div className='note-list-item-footer'>
      <Link to={`/note/${note.id}`}>{moment(note.created).format('MMMM Do YYYY')}</Link>
    </div>
    <div className='note-list-item-body'>
      {noteTemplate(note)}
    </div>
  </div>);
}

function IdeaListItem({ note }) {
  return (<div className='idea'>
    <h4>{note.title}</h4>
    <div className='idea-body'>{note.content}</div>
  </div>);
}

function QuoteListItem({ note }) {
  const source = (note.source) ? <span className='source'>{note.source}</span> : '';
  return (<div className='quote'>
    <blockquote>
      {note.content}
      {source}
    </blockquote>
  </div>);
}

function LinkListItem({ note }) {
  const commentary = (note.content) ? <span className='link-commentary'>{note.content}</span> : '';
  return (<div className='link'>
    <a href={note.source}>{note.title}</a>
    {commentary}
  </div>);
}

export default function NoteList({ notes }) {
  const sorted = notes.sort((a, b) => {
    return a.created >= b.created ? -1 : 1;
  });
  return (<div className='note-list'>
    {sorted.map((p) => <NoteListItem key={p.id} note={p} />)}
  </div>);
}



// WEBPACK FOOTER //
// ./src/components/NoteList.js